import VueProgressBar from "vue-progressbar";
import VueChatScroll from "vue-chat-scroll";
import VueLazyLoad from 'vue-lazyload';
import VueCookies from 'vue-cookies'
import VueToast from "vue-toast-notification";

// requires

require("./bootstrap");
// require('./notifications')
require('./helpers')
require('./components')

Vue.component(
    "main-slider",
    require("../components/front/home/MainSlider.vue").default
);

// utils

require('./js/modal-value-resetter')
require('./js/uploader')
require('./js/main')

// Vue libraries

Vue.use(VueCookies);
Vue.$cookies.config('1d');

Vue.use(VueChatScroll);

Vue.use(VueLazyLoad);

Vue.use(VueToast, {
    duration: 3000,
    position: "bottom-left"
});

Vue.use(VueProgressBar, {
    color: "#a6a9ff",
    failedColor: "#f9ac92",
    height: "2px",
    thickness: "5px",
    transition: {speed: "0.2s", opacity: "0.6s", termination: 300},
    autoRevert: true,
});

// prototypes

Vue.prototype.$word = window.word
Vue.prototype.$text = window.text

Vue.prototype.$bus = window.Bus = new Vue();

Vue.prototype._ = window._

Vue.prototype.$window = window

Vue.$events = window.Events = require('./events').default

window.goToWhatsApp = (phoneNumber) => window.open('https://api.whatsapp.com/send?phone=' + phoneNumber, '_blank')

Vue.prototype.$moment = window.moment = require('moment')

// launch
Vue.prototype.$user = window.user = Vue.observable(window.initialUser)
const app = new Vue({el: "#app"});
